import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { User, CreateUserDto, RegisterUserDto, FilterUsersDto } from './types/types';
import {formatRut} from "./utils/constants";



export class UserService {
  // 🔐 GET /users (requiere JWT)
  static async findAll(): Promise<User[]> {
    const filter: FilterUsersDto = {
      excludeUsers: [],
      role: [],
      turno: [],
      localidad: []
    }
    if(localStorage.getItem("organization")) {
      filter.organization = [localStorage.getItem("organization") || ""];
    }
    const response: AxiosResponse<User[]> = await AxiosService.post('/users/find', filter);
    return response.data;
  }
  // 🔐 GET /users (requiere JWT)
  static async find(): Promise<User[]> {
    const filter: FilterUsersDto = {
      excludeUsers: [],
      role: ["WORKER"],
      turno: [],
      localidad: []
    }
    if(localStorage.getItem("organization")) {
      filter.organization = [localStorage.getItem("organization") || ""];
    }
    const response: AxiosResponse<User[]> = await AxiosService.post('/users/find', filter);
    return response.data;
  }
  // 🔐 GET /users (requiere JWT)
  static async findBy(filter: FilterUsersDto): Promise<User[]> {
    const response: AxiosResponse<User[]> = await AxiosService.post('/users/find', filter);
    return response.data;
  }

  // GET /users/:id
  static async findOne(id: string): Promise<User | null> {
    const response: AxiosResponse<User> = await AxiosService.get(`/users/${id}`);
    return response.data;
  }
  
  // POST /users
  static async create(userData: CreateUserDto): Promise<User> {
    userData.rut = formatRut(userData.rut);
    const response: AxiosResponse<User> = await AxiosService.post('/users/basic', userData);
    return response.data;
  }
  
  // POST /users/register
  static async register(userData: RegisterUserDto): Promise<User> {
    userData.rut = formatRut(userData.rut);
    const response: AxiosResponse<User> = await AxiosService.post('/users/register', userData);
    return response.data;
  }


  // 🔐 PUT /users/:id (requiere JWT + rol admin)
  static async update(id: string, userData: CreateUserDto): Promise<User | null> {
    id = formatRut(id);
    const response: AxiosResponse<User> = await AxiosService.put(`/users/${id}`, userData);
    return response.data;
  }
  
  // 🔐 POST /users/:id/roles (requiere JWT + rol admin)
  static async updateRoles(id: string, roles: string[]): Promise<User | null> {
    id = formatRut(id);
    const response: AxiosResponse<User> = await AxiosService.post(`/users/${id}/roles`, { roles });
    return response.data;
  }

  // DELETE /users/:id
  static async remove(id: string): Promise<void> {
    id = formatRut(id);
    await AxiosService.delete(`/users/${id}`);
  }

  // PUT /users/:id/enable
  static async enable(id: string): Promise<void> {
    id = formatRut(id);
    await AxiosService.put(`/users/${id}/enable`, {});
  }
}